import {dateFormat} from "../dateFormat";
import {ADVANCE_PROCENT} from "../generalConstants.js/generalConstants";
import makeNameFromPersona from "../makeNameFromPersona";

export default class REQUEST_ASSET {
  constructor(request, language) {
    const requestInfo = request?.requestInfo;

    this.language = language;

    // this.skuPlan = request?.skuPlan;
    // this.SKU_PLAN = new SKU_PLAN_LIST_ASSET(request?.skuPlan);
    this.total = request?.total;
    this.services = requestInfo?.servicesInfo;

    this.advance = ADVANCE_PROCENT / 100;
    this.advanceForServices = requestInfo?.advanceForServices;

    this.totalSumWithoutDiscount = requestInfo?.totalSumWithoutDiscount;
    this.discount = requestInfo?.discount;
    this.totalSumWithDiscount = requestInfo?.totalSumWithDiscount;
    this.advancePrice = requestInfo?.advancePrice;
    this.advanceSkuSum = requestInfo?.advanceSkuSum;
    this.surchargePrice = requestInfo?.surchargePrice;

    this.sumPlan = +request?.sumPlan;

    this.skuRequests = request?.skuRequests || [];
    // this.skuRequestOrders = request?.skuRequests?.map(skuRequest => skuRequest?.order) || [];
    this.stockPool = request?.skuRequests?.[0]?.stockPool;
    this.packingSpaces = request?.packingSpaces || [];
    this.paymentDocs = request?.paymentDocs;
    this.requestSum = Number.parseFloat(request?.requestSum) || 0;
    this.cos = request?.cos;
  }

  get discountSum() {
    return this.totalSumWithoutDiscount - this.totalSumWithDiscount;
  }

  get requestAdvance() {
    return this.advanceForServices ? this.advancePrice : this.advanceSkuSum;
  }

  get skuRequestOrders() {
    return this.skuRequests?.map(skuRequest => skuRequest?.order) || [];
  }
  get orderNumberTableData() {
    return this.formExpandedTableData(this.skuRequestOrders?.map(order => order?.orderNumber));
  }
  get bringToDates() {
    return this.skuRequestOrders?.map(order => dateFormat(order?.co?.bringTo)) || [];
  }
  get bringToTableData() {
    return this.formExpandedTableData(this.skuRequestOrders?.map(order => dateFormat(order?.co?.bringTo)));
  }
  get countries() {
    return this.skuRequestOrders?.map(order => order?.co?.project?.delivery?.country?.shortName) || [];
  }
  get countryTableData() {
    return this.formExpandedTableData(
      this.skuRequestOrders?.map(order => order?.co?.project?.delivery?.country?.shortName),
    );
  }

  get managerCoTableData() {
    return this.formExpandedTableData(
      this.skuRequestOrders?.map(order =>
        makeNameFromPersona({persona: order?.co?.managerCo?.persona, language: this.language}),
      ),
    );
  }
  get logistTableData() {
    return makeNameFromPersona({persona: this.stockPool?.logist?.persona, language: this.language});
  }

  get productGroupTableData() {
    return this.formExpandedTableData(
      this.skuRequests?.map(({productGroup} = {}) => productGroup?.[this.language === "en" ? "engName" : "name"]),
    );
  }

  formExpandedTableData(data) {
    const uniqueData = [...new Set(data)];

    return uniqueData?.length > 1
      ? {
          text: uniqueData.join("\n"),
          expand: true,
        }
      : uniqueData?.[0] || " - ";
  }

  formCarrierAddress(carrier, notSpecifiedText = "not specified") {
    if (!carrier) return "";
    const contactsText =
      carrier?.contacts
        ?.map(
          (item, index) =>
            `${index + 1}. ${item?.title || item?.name || "---"} / ${item?.address || "---"} / ${
              item?.phone || "---"
            } / ${item?.email || "---"}\n`,
        )
        .join("") || notSpecifiedText;
    return contactsText;
  }

  get carrierAddress() {
    const carrier = this.stockPool?.cargo?.carrier;
    if (!carrier) return "";
    return this.formCarrierAddress(carrier);
  }

  get payedSum() {
    if (!Array.isArray(this.paymentDocs) || this.paymentDocs.length === 0) return 0;

    return this.paymentDocs.reduce((acc, paymentDoc) => acc + (parseFloat(paymentDoc?.sumFact) || 0), 0);
  }

  get isFullyPayed() {
    return this.requestSum <= this.payedSum;
  }

  get hasSomePayment() {
    if (!this.paymentDocs || this.paymentDocs.length === 0) return false;

    return this?.paymentDocs?.find(paymentDoc => +paymentDoc.sumFact > 0);
  }

  get cofSecondNumber() {
    const cofSecondNumbers = (this.cos || []).flatMap(cos => cos.cofs).map(cof => cof.cofSecondNumber);
    return cofSecondNumbers?.length > 1 ? {text: cofSecondNumbers, expand: true} : cofSecondNumbers[0];
  }
}
